<template>
  <div class="search-page">
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <div class="search-container">
      <span class="iconfont icon-sousuo"></span>
      <input
        class="input"
        type="text"
        placeholder="输入想要搜索的地区"
        v-model="searchText"
      />
      <div
        v-if="searchText"
        @click="clearInput"
        class="clear iconfont icon-cha"
      ></div>
    </div>
    <div class="search-bottom">
      <div class="s-scroll">
        <div
          style="width: 100%; height: 100%"
          v-if="areaData.length"
          v-show="searchText === ''"
        >
          <IndexList :list="areaData" @choose="bindChoose" />
        </div>
        <div class="select-list" v-if="searchAreaData.length">
          <div
            class="select-item"
            v-for="(item, index) in searchAreaData"
            :key="index"
            @click="bindSearchChoose(index)"
          >
            <div class="iconfont icon-sousuo"></div>
            <div class="name">{{ item.name }}</div>
            <div class="code">+{{ item.code }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IndexList from './index-list.vue'
export default {
  components: {
    IndexList
  },
  data() {
    return {
      areaData: [],
      searchAreaData: [], //搜藏出来的区号列表
      searchText: ''
    }
  },
  watch: {
    searchText() {
      if (this.searchText === '') {
        this.searchAreaData = ''
      } else {
        this.searchAreaData = this.filterAreaCode(
          this.searchText,
          this.areaData
        )
      }
    }
  },
  created() {
    this.getAreaCodeList()
  },
  methods: {
    bindClose() {
      this.$emit('close')
    },
    getAreaCodeList() {
      this.$toast.loading('加载中')
      let params = {
        headerObj: {
          clientversion: 12
        }
      }
      this.$http
        .postApp('/areaCode', params)
        .then((res) => {
          res = res.data
          this.$toast.clear()
          if (res.code == 200) {
            this.areaData = this.filterAreaData(res.data)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    //将后端给的arealist转成前端能用的
    filterAreaData(list) {
      let areaObj = {}
      list.map((item) => {
        let letter = (item.namePinyin && item.namePinyin.slice(0, 1)) || ''
        if (areaObj[letter]) {
          areaObj[letter].push(item)
        } else {
          areaObj[letter] = []
          areaObj[letter].push(item)
        }
      })
      console.log(areaObj)
      let res = []
      for (var key in areaObj) {
        let obj = {}
        obj.alpha = key.toUpperCase()
        obj.subItems = areaObj[key]
        res.push(obj)
      }
      console.log(res)
      return res
    },
    filterAreaCode(value, areaData) {
      let res = []
      areaData.map((item) => {
        item.subItems.map((item1) => {
          if (item1.name.indexOf(value) >= 0) {
            res.push(item1)
          }
        })
      })
      return res
    },
    //清除搜索文字
    clearInput() {
      this.searchText = ''
    },
    //从搜索框的答案中选择时
    bindSearchChoose(index) {
      let item = this.searchAreaData[index]
      console.log(item)
      this.$emit('change', item.code)
    },
    bindChoose(code) {
      this.$emit('change', code)
    }
  }
}
</script>
<style lang="scss" scoped>
.search-page {
  width: 100%;
  background-color: rgb(240, 242, 245);
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.close {
  position: absolute;
  padding: 10px;
  top: 5px;
  left: 5px;
  color: #000;
  font-size: 18px;
}

.search-bottom {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}

.s-scroll {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

.search-container {
  position: relative;
  margin: 60px auto 17px;
  width: 343px;
  height: 28px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 5px 12px;
  display: flex;
  align-items: center;
}

.search-container .iconfont {
  color: #bcbcbc;
}

.search-container .clear {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0%, -50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgb(200, 201, 205);
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
}

.search-container .input {
  flex: 1;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
  margin-left: 10px;
  background-color: transparent;
  border: none;
}

.search-container .placeholder {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.3);
  line-height: 17px;
}

.area-code-content {
  width: 100%;
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}

.area-scroll {
  width: 100%;
  height: 100%;
}

.area-letter-list .letter {
  padding-left: 20px;
  width: 100%;
  height: 32px;
  line-height: 32px;
  background: #f7f7f7;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.3);
}

.area-letter-list .area-item {
  display: flex;
  align-items: center;
  padding: 8px 50px 8px 20px;
  justify-content: space-between;
}

.area-item .name {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
}

.area-item .code {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
}

.letter-scroll {
  position: fixed;
  z-index: 99;
  right: 0px;
  top: 50%;
  transform: translate(0%, -50%);
}

.select-list {
  width: 100%;
  box-sizing: border-box;
  padding: 0px 28px;
}

.select-list .select-item {
  display: flex;
  align-items: center;
  height: 37px;
}

.select-item .fr-iconfont {
  color: #bcbcbc;
}

.select-item .name {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000;
  margin-left: 10px;
}

.select-item .code {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
}
</style>
